import { ReactNode, MouseEvent } from 'react';

import { ButtonOutlined, ButtonPrimary } from 'src/components/buttons';
import { ModalDefaultWrapper } from 'src/components/modal-wrapper';
import { Title } from 'src/components/titles';
import {
  ActionConfirmModalWrapper,
  ActionConfirmModalWrapperContent,
  ActionConfirmModalActions,
  Description,
  ActionConfirmModalHeader,
} from './styles';

type ActionConfirmModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmButtonText?: string;
  isLoading?: boolean;
  children?: ReactNode;
  title: string;
  description?: string;
};

export function ActionConfirmModal({
  isOpen,
  closeModal = () => ({}),
  onConfirm = () => ({}),
  onCancel = () => ({}),
  isLoading = false,
  children,
  title,
  description,
  confirmButtonText = 'Confirmar',
}: ActionConfirmModalProps) {
  const handleConfirm = (event?: MouseEvent<any>) => {
    event?.stopPropagation();
    onConfirm();
  };
  const handleCancel = (event?: MouseEvent<any>) => {
    event?.stopPropagation();
    closeModal();
    onCancel();
  };

  return (
    <ModalDefaultWrapper
      isOpenModal={isOpen}
      closeModal={closeModal}
      title={title}
    >
      <ActionConfirmModalWrapper>
        {description && (
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        )}

        {children && (
          <ActionConfirmModalWrapperContent>
            {children}
          </ActionConfirmModalWrapperContent>
        )}
        <ActionConfirmModalActions>
          <ButtonOutlined
            size="medium"
            label="Cancelar"
            onClick={(event) => handleCancel(event)}
          />
          <ButtonPrimary
            size="medium"
            label={confirmButtonText}
            isLoading={isLoading}
            onClick={(event) => handleConfirm(event)}
          />
        </ActionConfirmModalActions>
      </ActionConfirmModalWrapper>
    </ModalDefaultWrapper>
  );
}
